export default __webpack_public_path__ + "static/media/logo-metamask.94756c25.png";